import { FC, useState } from 'react'

import CurrencySelect from 'components/CurrencySelect'
import Popover from 'components/Popover'
import { Currency } from 'types/currency'

import {
  CurrencyPairDivider,
  CurrencyButton,
  CurrencySelectors,
  CurrencyPairToolbar,
  Wrapper,
} from './CurrencyPairHeader.styles'

export interface HeaderProps {
  baseCurrency: Currency
  quotedCurrency: Currency
  setBaseCurrency?: (value: Currency) => void
  setQuotedCurrency?: (value: Currency) => void
  readonly?: boolean
}

export const CurrencyPairHeader: FC<HeaderProps> = ({
  baseCurrency,
  quotedCurrency,
  setBaseCurrency,
  setQuotedCurrency,
  readonly,
}) => {
  const [showBaseCurrencySelect, setShowBaseCurrencySelect] =
    useState<boolean>(false)

  const [showQuotedCurrencySelect, setShowQuotedCurrencySelect] =
    useState<boolean>(false)

  const [
    baseCurrencyButtonReferenceElement,
    setBaseCurrencyButtonReferenceElement,
  ] = useState<HTMLButtonElement | null>(null)

  const [
    quotedCurrencyButtonReferenceElement,
    setQuotedCurrencyButtonReferenceElement,
  ] = useState<HTMLButtonElement | null>(null)

  return (
    <Wrapper>
      <CurrencyPairToolbar>
        <CurrencySelectors>
          <CurrencyButton
            size="small"
            ref={setBaseCurrencyButtonReferenceElement}
            onClick={() => {
              setShowQuotedCurrencySelect(false)
              setShowBaseCurrencySelect(!showBaseCurrencySelect)
            }}
            data-testid="base-currency-button"
            disabled={readonly}
          >
            <span>{baseCurrency.Symbol}</span>
          </CurrencyButton>
          <CurrencyPairDivider />
          <CurrencyButton
            size="small"
            ref={setQuotedCurrencyButtonReferenceElement}
            onClick={() => {
              setShowBaseCurrencySelect(false)
              setShowQuotedCurrencySelect(!showQuotedCurrencySelect)
            }}
            data-testid="quoted-currency-button"
            disabled={readonly}
          >
            <span>{quotedCurrency.Symbol}</span>
          </CurrencyButton>
        </CurrencySelectors>
      </CurrencyPairToolbar>
      {showBaseCurrencySelect && baseCurrencyButtonReferenceElement ? (
        <Popover
          referenceElement={baseCurrencyButtonReferenceElement}
          distance={8.5}
          placement="bottom"
        >
          <CurrencySelect
            onSelectValue={(e) => {
              setShowBaseCurrencySelect(false)
              setBaseCurrency(e.value)
            }}
          />
        </Popover>
      ) : null}

      {showQuotedCurrencySelect && quotedCurrencyButtonReferenceElement ? (
        <Popover
          referenceElement={quotedCurrencyButtonReferenceElement}
          distance={8.5}
          placement="bottom"
        >
          <CurrencySelect
            baseCurrency={baseCurrency}
            onSelectValue={(e) => {
              setShowQuotedCurrencySelect(false)
              setQuotedCurrency(e.value)
            }}
          />
        </Popover>
      ) : null}
    </Wrapper>
  )
}
